import { InputNumberFloat, InputNumberInteger } from "@components-common/forms";
import { Form } from "taltech-styleguide";

export const Corridor = () => (
  <tr className={"ebd-corridor-col"}>
    <td className={"align-middle py-2 w-10"}>C 1.0</td>
    <td className={"align-middle py-2 w-20"}></td>
    <td className="w-60">
      <div className={"d-flex"} style={{ minWidth: "300px" }}>
        <div className="col-3">
          <InputNumberFloat
            id={`corridor.width`}
            elementClass="ebd-input-width ms-2"
            showLabel={false}
            suffix=" m"
            maxValue={100}
          />
        </div>
      </div>
    </td>
    <td className="w-10"></td>
  </tr>
);
